import { franchiseAuthHeaders } from './franchiseFlowAuth';
import { guestAuthHeaders, hasGuestFlowAuth } from './guestFlowAuth';

/** Auth for public kiosk landing / register-form reads (franchise kiosk or guest QR). */
export function kioskConfigAuthHeaders(extra = {}) {
  if (hasGuestFlowAuth()) return guestAuthHeaders(extra);
  return franchiseAuthHeaders(extra);
}
